import { render, staticRenderFns } from "./ppmview.vue?vue&type=template&id=a372e974&scoped=true&"
import script from "./ppmview.vue?vue&type=script&lang=js&"
export * from "./ppmview.vue?vue&type=script&lang=js&"
import style0 from "./ppmview.vue?vue&type=style&index=0&id=a372e974&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a372e974",
  null
  
)

export default component.exports